import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GuaranteeNotes } from "@app/models/guarantee-notes";
import { GuaranteeAgreementNotesService } from "@app/services/guarantee-agreement-notes.service";

@Component({
    selector: "app-select-guarantee-note-popup",
    templateUrl: "./select-guarantee-note-popup.component.html",
    styleUrls: ["./select-guarantee-note-popup.component.css"],
    standalone: false
})
export class SelectGuaranteeNotePopupComponent implements OnInit {
  @Input() guaranteeNotes: Array<GuaranteeNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedGuaranteeNotes: Array<GuaranteeNotes>;
  @Output() onSubmit = new EventEmitter<Array<GuaranteeNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private guaranteeNotesService: GuaranteeAgreementNotesService) {}

  ngOnInit() {
    if (!this.selectedGuaranteeNotes) {
      this.selectedGuaranteeNotes = [];
    }
    for (const root of this.guaranteeNotes || []) for (const note of this.findAllChidren(root)) if (note.mandatory && !this.selectedGuaranteeNotes.some((selected) => selected.id === note.id)) this.selectedGuaranteeNotes.push(note);
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(guaranteeNote: GuaranteeNotes) {
    if (!guaranteeNote) {
      return;
    }

    const fullNote = this.guaranteeNotesService.findGuaranteeNoteById(guaranteeNote.id, this.guaranteeNotes) || guaranteeNote;
    const allDescendants = this.findAllChidren(fullNote);
    const updated = [...this.selectedGuaranteeNotes];
    for (const item of allDescendants) {
      if (!updated.some((p) => p.id === item.id)) {
        updated.push(item);
      }
    }
    this.selectedGuaranteeNotes = updated;
  }

  onSave() {
    this.onSubmit.emit(this.selectedGuaranteeNotes);
  }

  deleteSelectedGuaranteeNote(guaranteeNote: GuaranteeNotes) {
    if (!guaranteeNote) {
      return;
    }

    const fullNote = this.guaranteeNotesService.findGuaranteeNoteById(guaranteeNote.id, this.guaranteeNotes) || guaranteeNote;
    const removeIds = new Set(this.findAllChidren(fullNote).map((item) => item.id));
    this.selectedGuaranteeNotes = this.selectedGuaranteeNotes.filter((item) => !removeIds.has(item.id));
  }

  checkIfParentIdInTheList(checkArray: GuaranteeNotes[], guaranteeNote: GuaranteeNotes) {
    const set1 = new Set(checkArray);
    const parents = this.guaranteeNotesService.findGuaranteeNoteParents(guaranteeNote, this.guaranteeNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(guaranteeNote: GuaranteeNotes): GuaranteeNotes[] {
    let items: GuaranteeNotes[] = [];
    if (guaranteeNote) {
      items.push(guaranteeNote);
      if (guaranteeNote.subGuaranteeNotes && guaranteeNote.subGuaranteeNotes.length > 0) {
        guaranteeNote.subGuaranteeNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
